<template>
  <div class="container multi-card-container main-view">
    <div class="row">

      <div class="col-lg-12">
        <h1>{{$t('homescreen_summary')}}</h1>
      </div>
      <achievements-component :user="user ? user : null" @claimSuccess="onAchievementClaimSuccess"/>

      <card-tree-component :data="depositData.environmentalData" :level="user.user_level"/>

      <card-chart-component :data="depositData.typeData" />

      <activities-component :data="depositData.activitiesData"
                            :dataLoading="spinners.activityListIsLoading"
                            :paginationData="depositData.activitiesMetaData"
                            @pageChange="onActivityListPageChange"/>
    </div>
  </div>
</template>

<script>
import CollapseTransition from '@ivanv/vue-collapse-transition';
import AchievementsComponent from '../../../components/Home/AchievementsComponent';
import CardTreeComponent from '../../../components/Home/CardTreeComponent';
import CardChartComponent from '../../../components/Home/CardChartComponent';
import ActivitiesComponent from '../../../components/Home/ActivitiesComponent';
import { mapGetters, mapActions } from 'vuex';
import forEach from 'lodash.foreach';
import VuexTypes from '@/store/types/index';
import DepositService from '@/services/deposit';
import Vue from 'vue';
import statuses from '@/store/statuses';

const AuthTypes = VuexTypes.auth;
const DepositTypes = VuexTypes.deposit;
const UsersTypes = VuexTypes.users;

export default {
  components: {
    CollapseTransition,
    AchievementsComponent,
    CardTreeComponent,
    CardChartComponent,
    ActivitiesComponent
  },
  props: [
  ],
  data () {
    return {
      depositData: {
        environmentalData: {
          kwh: 0,
          co2: 0,
          water: 0,
          oxygen: 0,
          tree: 0
        },
        typeData: [],
        activitiesData: []
      },
      spinners: {
        activityListIsLoading: true,
      }
    }
  },
  mounted () {
    DepositService.getUserEnvironmentalData().then((res) => {
      if (res.data.data) {
        Vue.set(this.depositData, 'environmentalData', res.data.data);
      }
    });
    DepositService.getUserTypeData().then((res) => {
      if (res.data.data) {
        Vue.set(this.depositData, 'typeData', res.data.data);
      }
    });

    this.getActivityListData(1);
  },
  created () {
  },
  computed: {
    ...mapGetters('Auth', ['user']),
    ...mapGetters('Users', ['userActivityList'])
  },
  methods: {
    ...mapActions('Users', [
      UsersTypes.USER_ACTIVITY_LIST
    ]),
    setExpand (e, item) {
      e.preventDefault();
      if (!this.visitExpanded[item]) {
        Vue.set(this.visitExpanded, item, true);
        Vue.set(this.visitTransitioned, item, true);
      } else {
        let that = this;
        Vue.set(this.visitTransitioned, item, false);
        setTimeout(function () {
          Vue.set(that.visitExpanded, item, false);
        }, 350);
      }
    },
    fillActivityData() {
      const result = [];

      forEach(this.userActivityList.data.data, (item) => {
        let activityData = {
          activity_type: item.activity_type,
          time: item.time,
          name: item.name,
          subtitle: item.subtitle,
          discount_code: item.discount_code,
          address: item.address,
          start_time: item.start_time,
          deposits: item.deposits || [],
          deposit_count_sum: item.deposit_count_sum
        };

        activityData.credit_sum = item.activity_type === 'achievement' ? item.credit_sum : item.credit_sum;

        result.push(activityData);
      });

      this.depositData.activitiesData = result;
      this.depositData.activitiesMetaData = this.userActivityList.data.meta;
    },
    getActivityListData(page) {
      this.spinners.activityListIsLoading = true;
      this.USER_ACTIVITY_LIST(page);
    },
    onActivityListPageChange(page) {
      this.getActivityListData(page);
    },
    onAchievementClaimSuccess() {
      this.getActivityListData(1);
    }
  },
  watch: {
    userActivityList: {
      handler() {
        if (this.userActivityList.status === statuses.LOADED) {
          this.fillActivityData();
          this.spinners.activityListIsLoading = false;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .container.multi-card-container {
    margin-bottom: 0;
  }
</style>